import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { StatusBadge } from "../components/ui/StatusBadge";
import { Button } from "../components/ui/Button";
import Logo from "../components/Logo";
import {
  ClockCountdown,
  SignOut,
} from "@phosphor-icons/react";

export default function PendingPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-ink-50 flex flex-col" data-testid="pending-page">
      <div className="absolute inset-0 bg-grid opacity-40 pointer-events-none" />

      <header className="relative border-b border-ink-200 bg-white">
        <div className="mx-auto flex h-16 max-w-4xl items-center justify-between px-6">
          <Logo size="md" />
          <button
            onClick={handleLogout}
            data-testid="pending-header-logout-btn"
            className="inline-flex items-center gap-1.5 rounded-sm border border-ink-300 px-3 py-1.5 text-xs font-medium text-ink-700 transition-crisp hover:bg-ink-100"
          >
            <SignOut size={14} weight="bold" />
            Abmelden
          </button>
        </div>
      </header>

      <div className="relative flex-1 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-2xl border border-ink-200 bg-white rounded-sm relative">
          <div className="absolute top-0 left-0 h-1 w-24 bg-brand-400" aria-hidden="true" />

          <div className="px-10 py-12">
            <div className="flex items-center justify-between mb-8">
              <div className="text-xs uppercase tracking-widest font-semibold text-warm-500">
                Konto-Status
              </div>
              <StatusBadge status={user?.status || "ausstehend"} />
            </div>

            <div className="flex items-start gap-5 mb-10">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-sm border border-brand-300 bg-brand-50">
                <ClockCountdown size={24} weight="duotone" className="text-brand-500" />
              </div>
              <div>
                <h1
                  className="font-cabinet text-3xl sm:text-4xl tracking-tight text-ink-900 font-medium leading-tight"
                  data-testid="pending-title"
                >
                  Ihr Konto wird geprüft.
                </h1>
                <p className="mt-3 text-base text-warm-700 leading-relaxed">
                  Vielen Dank für Ihre Registrierung
                  {user?.name ? (
                    <>
                      , <span className="font-semibold text-ink-900">{user.name}</span>
                    </>
                  ) : (
                    ""
                  )}
                  . Ein Administrator prüft Ihr Konto manuell und schaltet den
                  Zugang zu <span className="font-semibold text-ink-900">ET</span>{" "}
                  nach erfolgreicher Prüfung frei.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-0 border-y border-ink-200 sm:divide-x sm:divide-ink-200">
              <div className="p-5">
                <div className="text-[10px] uppercase tracking-widest font-semibold text-warm-500 mb-1.5">
                  Registriert als
                </div>
                <div className="font-medium text-ink-900 text-sm" data-testid="pending-user-email">
                  {user?.email || "—"}
                </div>
              </div>
              <div className="p-5">
                <div className="text-[10px] uppercase tracking-widest font-semibold text-warm-500 mb-1.5">
                  Aktueller Status
                </div>
                <div className="font-medium text-ink-900 text-sm">
                  Ausstehend &mdash; auf manuelle Freigabe wartend
                </div>
              </div>
            </div>

            <div className="mt-10 flex flex-col sm:flex-row gap-3">
              <Button
                onClick={handleLogout}
                variant="secondary"
                size="lg"
                data-testid="pending-logout-btn"
              >
                <SignOut size={16} weight="bold" />
                Abmelden
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
